import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'
import Link from 'components/common/Link/Link'

const BOTPromotionsLink = ({ displayName, link: { path = '' } = {}}) =>
  <MorePromotions>
    <Link data-promotions-all-details-link bolder to={ path }>
      { displayName } <LinkIcon asset="caret-blue-right" />
    </Link>
  </MorePromotions>

BOTPromotionsLink.type = 'BOTPromotionsLink'

export default BOTPromotionsLink

BOTPromotionsLink.propTypes = {
  displayName: PropTypes.string,
  link: PropTypes.shape({
    path: PropTypes.string
  })
}

const MorePromotions = styled.div`
  margin: 8px auto 0;
  padding-bottom: 20px;
  text-align: center;
  ${Media.mobile`
    max-width: 90vw;
  `}
`

const LinkIcon = styled(Icon)`
  width: 6px;
  margin-top: -2px;
`
